export default __webpack_public_path__ + "a68fcb7bb02f360d3aca540bfd1db018.ico";